// extracted by mini-css-extract-plugin
export default {"stack":"StickySideRailAds_stack__HhGwi","slot":"StickySideRailAds_slot__F+4ly"};